<svg class="{iconsClasses}" width="42" height="41" viewBox="0 0 196 193" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <path id="shape" d="M 71 0 C 119 0, 142 37, 142 76 S 95 166, 71 193 C 46 166, 0 115, 0 76 S 23 0, 71 0Z" />
    </defs>
    <use xlink:href="#shape" class="clusterIcon3" transform="translate(54)" fill="#660014"/>
    <use xlink:href="#shape" class="clusterIcon2" transform="translate(27)" fill="#990016"/>
    <use xlink:href="#shape" class="clusterIcon1" transform="translate(0)"  fill="#CC001E"/>
    <text class="clusterIconText"  x="68" y="75" dominant-baseline="middle" text-anchor="middle" font-size="50px">{clusterSize}</text>
</svg>